// Libraries
import React, {forwardRef} from 'react'
import classnames from 'classnames'

// Types
import {StandardFunctionProps, InfluxColors} from '../../Types'

// Styles
import './InfluxDataLogo.scss'

export interface InfluxDataLogoProps extends StandardFunctionProps {
  /** Coloration of the SVG image */
  fill?: InfluxColors | string
}

export type InfluxDataLogoRef = SVGSVGElement

export const InfluxDataLogo = forwardRef<
  InfluxDataLogoRef,
  InfluxDataLogoProps
>(
  (
    {
      id,
      style,
      fill = InfluxColors.White,
      testID = 'logo--influxdata',
      className,
    },
    ref
  ) => {
    const logoClass = classnames('cf-logo--influxdata', {
      [`${className}`]: className,
    })

    const logoStyle = {fill, ...style}

    return (
      <svg
        version="1.1"
        ref={ref}
        id={id}
        data-testid={testID}
        style={logoStyle}
        x="0px"
        y="0px"
        viewBox="0 0 1080 300"
        width="1080"
        height="300"
      >
        <path
          className={logoClass}
          d="M730.5,274.6l-1.3-10.1h-17.6l-4.8,10.1h-9.6l23.3-47.5h12l7.1,47.5H730.5z M725.7,234.2L715.1,257h13.3
	L725.7,234.2z M770.4,240.6l-1.9,6.8c-2-0.6-4.8-1-6.5-1c-5,0-6.6,1.4-7.5,6.3l-2.1,11.8c-0.1,0.4-0.1,0.9-0.1,1.2
	c0,1.4,0.6,2.3,2.6,2.3c2.8,0,7.3-1.2,10.2-2.2l0.9,6.9c-3.1,1.5-7.5,2.6-11.8,2.6c-7.4,0-10.5-3.1-10.5-8.6c0-1.1,0.1-2.1,0.4-3.4
	l2.1-11.7c1.7-9.6,6.3-12.4,16-12.4C764.8,239.2,768.4,239.8,770.4,240.6z M781.5,275.3c-5.4,0-7.8-3.4-7-8.4l3.6-20.2h-5.6l1.3-6.8
	h5.5l1.6-9l8.8-1.2l-1.8,10.2h8.8l-1.4,6.8h-8.7l-3.5,19.8c-0.2,1.2,0.1,1.8,1.4,1.8c1.7,0,4-0.8,6-1.6l1.9,5.8
	C789.5,274.2,785.6,275.3,781.5,275.3z M816.6,235.5l1.7-9.8l8.8-1.2l-1.7,9.7L816.6,235.5z M809.7,274.6l6-34.1l8.8-1.2l-6.2,35.3
	L809.7,274.6L809.7,274.6z M847.4,274.6l4.3-24.7c0.1-0.4,0.1-0.8,0.1-0.9c0-0.9-0.4-1.5-1.8-1.5c-2.3,0-7.1,2.1-10.3,4.1l-4.1,23.1
	H827l6-34l7.4-1.3l-0.1,4.2c4.6-2.5,10-4.3,14-4.3c4.8,0,6.3,3.1,6.3,6.9c0,1.4-0.1,2.3-0.4,3.4l-4.4,25.1h-8.4V274.6z M904.1,234.9
	l-7,39.7h-8.8l7-39.7H882l1.4-7.8h35.5l-1.4,7.8H904.1z M922.9,235.5l1.7-9.8l8.8-1.2l-1.7,9.7L922.9,235.5z M916,274.6l6-34.1
	l8.8-1.2l-6.2,35.3L916,274.6L916,274.6z M974,274.6l4.3-24.7c0.1-0.4,0.1-0.8,0.1-0.9c0-0.9-0.4-1.5-1.8-1.5
	c-2.3,0-7.1,2.1-10.3,4.1l-4.1,23.1h-8.6l4.3-24.7c0.1-0.4,0.1-0.8,0.1-0.9c0-0.9-0.4-1.5-1.8-1.5c-2.3,0-7.1,2.1-10.3,4.1
	l-4.1,23.1h-8.6l6-34l7.4-1.3l-0.1,4.2c4.6-2.5,10-4.3,14-4.3c3.6,0,5.4,1.9,6.1,4.4c4.9-2.9,10.3-4.4,14.3-4.4
	c4.8,0,6.3,3.1,6.3,6.9c0,1.2-0.1,2.4-0.4,3.4l-4.4,25.1H974V274.6z M1000.2,262.8l-0.3,1.6c-0.4,2-0.4,3.7,2.7,3.7
	c3.7,0,8.8-1.7,13.3-4l1.9,6.6c-4.2,2.6-10.6,4.6-16.4,4.6c-9.2,0-11-5.1-9.8-12.4l1.9-10.5c1.5-8.2,5.3-13.2,15.8-13.2
	c6.6,0,11.1,3.4,11.1,9.1c0,6.2-4.1,9.8-13.5,12.7C1002.7,262.2,1001.9,262.4,1000.2,262.8z M1006.8,253.6c3.8-1.2,5.5-2.7,5.5-5
	c0-1.6-1.4-2.7-3.6-2.7c-3.9,0-5.8,2.4-6.4,5.7l-0.6,3.6C1002.8,254.8,1003.3,254.6,1006.8,253.6z M744,168.7
	c11.5,0,25.8-7.5,37.5-17.8l9.7-54.2c-7.3-1.8-14.3-2.9-21.6-2.9c-16.6,0-23.4,5.7-26.9,25.7l-6.4,36.6c-0.4,2.2-0.7,3.7-0.7,5.3
	C735.6,167.1,738.5,168.7,744,168.7z M778.4,173.3l1.3-10.3c-10.4,8.8-23.8,14.9-36.9,14.9c-11.5,0-17.7-4.2-17.7-15.1
	c0-2,0.2-4.2,0.7-6.6l6.8-38.4c4.2-24.3,15.2-33.1,38.2-33.1c6,0,16.3,1.1,21.8,2.9l6.2-35.5c0-0.9,0.9-2.2,2.4-2.4l5.7-0.9
	c1.1-0.2,2.6,0.2,2.2,2.4l-21.6,122.2c0,0.9-0.4,2.6-2.4,2.6h-5.3C779.1,175.9,778.2,175.5,778.4,173.3z M833.6,168.7
	c11,0,24.8-7.5,36.3-17.8l9.5-54.2c-5-1.3-13.4-2.9-20.7-2.9c-16.6,0-22.9,5.9-26.3,25.7l-6.3,36.6c-0.4,2.2-0.6,3.7-0.6,5.3
	C825.4,167.1,828.2,168.7,833.6,168.7z M866.8,173.3l1.3-10.3c-10.1,8.8-22.7,14.9-35.4,14.9c-11.2,0-17.3-4.2-17.3-15.1
	c0-2,0.2-4.2,0.6-6.6l6.7-38.4c4.1-23.5,13.6-33.1,37.4-33.1c8.2,0,20.1,2,30.4,5.9L876,173.3c0,0.9-0.4,2.6-2.4,2.6h-5.2
	C867.5,175.9,866.6,175.5,866.8,173.3z M981.3,168.7c11,0,24.8-7.5,36.3-17.8l9.5-54.2c-5-1.3-13.4-2.9-20.7-2.9
	c-16.6,0-22.9,5.9-26.3,25.7l-6.3,36.6c-0.4,2.2-0.6,3.7-0.6,5.3C973.1,167.1,975.9,168.7,981.3,168.7z M1014.3,173.3l1.1-10.3
	c-10.1,8.8-22.7,14.9-35.4,14.9c-11.2,0-17.3-4.2-17.3-15.1c0-2,0.2-4.2,0.6-6.6l6.7-38.4c4.1-23.5,13.6-33.1,37.4-33.1
	c8.2,0,20.1,2,30.4,5.9l-14.5,82.7c0,0.9-0.4,2.6-2.4,2.6h-5.2C1015,175.9,1014.1,175.5,1014.3,173.3z M958.3,94.2
	c-0.2,0.9-0.6,1.3-1.9,1.5H932l-11.4,66c-0.2,1.3-0.4,2.4-0.4,3.3c0,3.5,1.9,4.4,6,4.4c12.2,0,15.6-1.3,21.6-3.7
	c0.6-0.2,1.7-0.4,1.9,0.4l1.3,3.5c0.4,0.9,0.6,2.2-1.3,3.3c-6.2,3.1-18.4,5-25.3,5c-8.8,0-14.4-3.7-14.4-11.8c0-1.1,0.2-2.2,0.4-3.5
	L922,95.5h-15c-1.5,0-1.5-1.1-1.5-1.5l0.9-5.7c0.2-1.3,1.5-1.5,1.9-1.5h15.2l3.4-19.7c0-0.9,0.9-2.2,2.4-2.4l5.6-0.9
	c1.1-0.2,2.6,0.2,2.1,2.4l-3.4,20.6h24.6c0.9,0,1.7,0,1.3,1.5L958.3,94.2z M719.2,88.8l-36.1,47.9l18.8,41.1h-23.4
	c-1.5,0-3.1-1.1-3.5-2.2l-9.4-20l-16.6,20c-1.1,1.3-3.5,2.2-5,2.2h-24l35.4-44.6L636.2,91l22.3-3.3c1.3-0.2,2.6,0.2,3.3,1.7
	l10.7,27.4l18.1-26.3c0.7-0.9,2-1.7,3.1-1.7L719.2,88.8L719.2,88.8z M610.6,174.3c0,0.7-0.4,1.5-1.3,1.5h-19.9
	c-0.9,0-1.1-1.1-1.1-1.5l-0.2-6.6c-14.1,6.6-25.2,10.1-35.6,10.1c-11.9,0-16.6-7-16.6-18.3c0-3.7,0.2-6.6,0.9-10.3l10.4-58.5
	c0-0.9,0.7-2.4,3.1-2.9l21.7-3.1c0.9-0.2,2.2-0.2,2,1.5l-10.6,60.5c-0.2,1.1-0.4,2.2-0.4,2.9c0,2,0.9,2.9,3.5,2.9
	c4.9,0,16.8-5.3,23.4-8.6l9.3-53.3c0-0.9,0.7-2.4,3.1-2.9l21.7-2.9c1.1-0.2,2.4-0.2,2.2,1.5L610.6,174.3z M396.6,84.7
	c11.8,0,16.1,6.9,16.1,18c0,3-0.2,5.6-0.9,10.2L401.7,171c-0.6,3.9-1.7,3.9-3.9,3.9h-18.9c-3,0-3.2-0.2-2.6-3.9l9.7-56.1
	c0.2-1.1,0.4-2.2,0.4-2.8c0-1.9-0.9-2.6-3.4-2.6c-4.7,0-15.9,4.8-22.7,8.5l-9.2,53c-0.6,3.9-1.7,3.9-3.9,3.9h-18.9
	c-3,0-3.2-0.2-2.6-3.9l13.8-79.8c0.2-0.9,1.1-2.6,3.9-3l16.5-2.8c0.9-0.2,2.4-0.4,2.4,1.5l-0.2,7.8
	C375.8,88.2,386.5,84.7,396.6,84.7z M323.3,48.6c1.9,0,2.3,0,2.1,1.3l-4,22.7c-0.4,2.8-0.9,3-3,3.2l-20.7,2.8
	c-2.3,0.2-2.6,0.2-2.1-2.4l3.8-21.8c0.2-0.9,0.6-2.6,3-2.8L323.3,48.6z M304.1,173.7c-0.9,3.9-2,3.9-4,4.1h-19.7
	c-2.9,0-3.3-0.4-2.9-3.5l14.7-80.9c0-0.9,0.7-2.4,3.1-2.8l21.8-2.8c1.1-0.2,2.5-0.2,2.2,1.5L304.1,173.7z M514.3,172.6
	c-0.7,3.9-1.7,3.9-4.1,4.6h-19.1c-3,0-3.3-0.2-2.6-3.9l17.6-100.1c-7-1.7-19.4-3.3-27-3.3c-5.7,0-7.6,1.5-8.5,6.1l-2.4,12.8h20.7
	c0.9,0,2.2,0.4,1.7,1.7l-4.6,17.8c-0.4,1.3-0.7,1.3-1.7,1.3h-19.8L452.1,180c-2.2,11.7-6.1,20.2-18.5,32.7c-1.5,1.5-2.2,1.7-3.5,0.4
	l-13.5-12.6c-1.1-0.9-1.5-1.3,0-2.8c7.6-8,8.9-12.8,10.2-20.8l12-67.6h-11.1c-1.1,0-1.5-0.9-1.3-1.5l3-16.9c0.2-1.1,0.4-2.4,3-2.4
	h10l2-11.7c3.7-20.4,11.3-28.2,34.2-28.2c7.2,0,19.8,1.3,30.9,4.3l24.6-4.1c1.1-0.2,2-0.2,1.7,1.5L514.3,172.6z M1051.9,50.8
	c-5.2,0-9.2,4-9.2,9.2s4,9.2,9.2,9.2s9.2-4,9.2-9.2C1061.1,54.9,1056.9,50.8,1051.9,50.8z M1051.9,71.2c-6.3,0-11.2-4.9-11.2-11.2
	s4.9-11.2,11.2-11.2s11.2,4.9,11.2,11.2C1063.1,66.3,1058,71.2,1051.9,71.2z M1054.8,57.3v-0.4c0-0.9-0.4-1.1-1.6-1.1h-2.7l-0.7,4.5
	h2.7c1.6,0,1.8-0.4,2-1.6L1054.8,57.3z M1051.9,62.3h-2.4l-0.7,4.5h-2.5l2.2-13.2h4.9c2.7,0,4,1.1,4,2.9v0.9l-0.2,1.8
	c-0.2,1.8-0.9,2.5-2.5,3.1l2.5,4.7h-2.7L1051.9,62.3z M191.7,147.8c2.4-0.4,3.9-2.8,3.2-5.4l-16-69.6c-0.6-2.4-3-3.9-5.4-3.2
	l-37.7,8.6c-2.4,0.6-3.9,3-3.2,5.4l16,69.6c0.7,2.4,3,3.9,5.4,3.2L191.7,147.8z M186.7,157.1c1.7-1.7,1.3-2.8-1.1-1.9l-31.4,7.1
	c-2.4,0.4-5,2.8-5.6,5.2l-9.5,30.7c-0.6,2.4,0.2,3,1.9,1.3L186.7,157.1z M126,206.8c2.4,0.4,4.8-0.9,5.6-3.2l11.5-36.7
	c0.7-2.4-0.6-5-3-5.6l-68.5-21c-2.4-0.6-5,0.6-5.6,3L54.5,180c-0.6,2.4,0.7,5,3,5.6L126,206.8z M49.3,171.1c0.4,2.4,1.5,2.4,2.2,0
	l9.5-30.7c0.6-2.4,0-5.8-1.7-7.6l-21.9-23.5c-1.5-1.7-2.6-1.3-1.9,1.1L49.3,171.1z M36.6,94c-1.7,1.5-1.9,4.3-0.2,6.3l26.2,28.3
	c1.7,1.7,4.6,1.9,6.3,0.2l52.4-48.6c1.7-1.7,1.9-4.5,0.2-6.3L95.3,45.6c-1.7-1.7-4.6-1.9-6.3-0.2L36.6,94z M142.9,152.3l-15.2-65.7
	c-0.7-2.4-2.6-3-4.3-1.3L74,131.1c-1.7,1.7-1.3,3.7,1.1,4.3l64.6,19.9C142.1,156,143.6,154.7,142.9,152.3z M105.7,45.4
	c-2.4-0.6-2.8,0.2-0.9,2.2l21.9,23.5c1.7,1.7,5,2.8,7.4,2.2l31.4-7.1c2.4-0.6,2.4-1.7,0-2.4L105.7,45.4z M212.5,145.6
	c1.1,4.5-0.7,10.4-4.1,13.8l-66.7,61.8c-2.6,2.2-6.5,3.7-10.2,3.7c-1.3,0-2.6,0-3.7-0.4l-81.5-25.3c-4.6-1.3-8.7-5.8-9.7-10.4
	l-20.4-88.6c-1.1-4.3,0.7-10.4,4.1-13.4l62.4-57.9c2.6-2.2,6.5-3.7,10.2-3.7c1.3,0,2.6,0,3.7,0.4l87.1,26.8
	c4.6,1.3,8.7,5.8,9.7,10.4L212.5,145.6z"
        />
      </svg>
    )
  }
)

InfluxDataLogo.displayName = 'InfluxDataLogo'
